import { render, staticRenderFns } from "./UltimaCarga.vue?vue&type=template&id=909efd3c&scoped=true"
import script from "./UltimaCarga.vue?vue&type=script&lang=js"
export * from "./UltimaCarga.vue?vue&type=script&lang=js"
import style0 from "./UltimaCarga.vue?vue&type=style&index=0&id=909efd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909efd3c",
  null
  
)

export default component.exports